import { render, staticRenderFns } from "./AffPaymentAppBaseForm.vue?vue&type=template&id=1857f4a8&scoped=true&"
import script from "./AffPaymentAppBaseForm.vue?vue&type=script&lang=js&"
export * from "./AffPaymentAppBaseForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1857f4a8",
  null
  
)

export default component.exports